import React from 'react';
import { Container } from 'react-bootstrap';

export default function SprintTextSection({ 
    label, 
    titlePrefix, 
    highlightText, 
    titleSuffix, 
    paragraphs, 
    extraClasses = '' 
}) {
    return (
        <section className={`sprint-what ${extraClasses}`}>
            <Container>
                <div className="sprint-what-content sprint-reveal">
                    {label && <span className="sprint-section-label center">{label}</span>}
                    <h2>
                        {titlePrefix} {highlightText && <span className="highlight">{highlightText}</span>} {titleSuffix}
                    </h2>
                    
                    {paragraphs && paragraphs.map((p, idx) => (
                        <p key={idx}>{p}</p>
                    ))}
                    
                    <div className="sprint-what-divider"></div>
                </div>
            </Container>
        </section>
    );
}
